import { RemoteCardIssuePointsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const cardIssuePointsService = new RemoteCardIssuePointsService(httpClient)
